function updateInventoryBadges() {
  const nodes = Array.from(document.querySelectorAll('.js-inv-badge[data-total-inventory]'));
  if (!nodes.length) return;

  nodes.forEach(node => {
    const totalInventory = parseInt(node.getAttribute('data-total-inventory') || '0', 10);
    const threshold = parseInt(node.getAttribute('data-threshold') || '10', 10);

    if (totalInventory > 0 && totalInventory < threshold) {
      const template = node.getAttribute('data-text-template') || '{qty} LEFT 🔥';
      node.textContent = template.replace('{qty}', totalInventory);
      node.hidden = false;
    } else if (totalInventory === 0) {
      node.hidden = true; // sold out handled elsewhere
    } else {
      node.hidden = true; // plenty in stock
    }
  });
}

let facetObserver = null;

function setupObservers() {
  const facetMain = document.querySelector('#facet-main');
  if (facetMain) {
    if (facetObserver) {
      facetObserver.disconnect();
      facetObserver = null;
    }
    
    facetObserver = new MutationObserver((mutations) => {
      let shouldUpdate = false;
      mutations.forEach((mutation) => {
        if (mutation.type === 'childList') {
          mutation.addedNodes.forEach((node) => {
            if (node.nodeType === 1) { // Element node
              if (node.classList && (
                node.classList.contains('product-item') ||
                node.classList.contains('product-list__inner') ||
                (node.querySelector && node.querySelector('.product-item, .js-inv-badge'))
              )) {
                shouldUpdate = true;
              }
              if (node.querySelector && node.querySelector('.js-inv-badge')) {
                shouldUpdate = true;
              }
            }
          });
        }
      });
      
      if (shouldUpdate) {
        requestAnimationFrame(() => {
          setTimeout(() => {
            updateInventoryBadges();
          }, 100);
        });
      }
    });

    facetObserver.observe(facetMain, {
      childList: true,
      subtree: true
    });
  }
}

function initInventoryBadges() {
  updateInventoryBadges();
  setupObservers();

  const paginationNode = document.getElementById('Huratips-Pagination');
  if (paginationNode) {
    let previousText = '';
    
    const observer = new MutationObserver(() => {
      const linkElement = paginationNode.querySelector('a');
      if (linkElement) {
        const currentText = linkElement.textContent.trim();
        
        if (previousText === 'Loading...' && currentText === 'Loading More') {
          updateInventoryBadges();
        }
        
        previousText = currentText;
      }
    });

    observer.observe(paginationNode, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initInventoryBadges);
} else {
  initInventoryBadges();
}

document.addEventListener('facet:criteria-changed', () => {
  setTimeout(() => {
    updateInventoryBadges();
    setupObservers();
  }, 200);
  
  setTimeout(() => {
    updateInventoryBadges();
  }, 500);
});